import { Box } from '@ethings/ui-toolkit';
import { styled } from '@mui/material';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FC } from 'react';
import { useAuth, useAuthenticated } from '../../auth';
import { useSwitchAwareConfig } from '../../hooks';
import { useHasAuthorization } from '../../util';
import { SideMenuBox } from './side-menu-box';
import { SideMenuItem } from './side-menu-item';
import { SideMenuItemDefinition } from './side-menu.types';
import { isSideMenuItemVisible } from './side-menu.utils';

interface SideMenuFooterProps {
  isOpen: boolean;
  menuItems: SideMenuItemDefinition[];
}

export const SideMenuFooter: FC<SideMenuFooterProps> = ({ isOpen, menuItems }) => {
  const flags = useFlags();
  const { state } = useAuth();
  const { hasAuthorization } = useHasAuthorization(state);
  const config = useSwitchAwareConfig();
  const { account } = useAuthenticated();
  const visibleMenuItems = menuItems.filter((menuItem) => isSideMenuItemVisible(menuItem, account, flags, hasAuthorization, config));

  if (!visibleMenuItems.length) return null;

  return (
    <Root>
      <StyledSideMenuBox isOpen={isOpen}>
        {visibleMenuItems.map((menuItem, i) => <SideMenuItem key={i} menuItem={menuItem} isOpen={isOpen} />)}
      </StyledSideMenuBox>
    </Root>
  );
};

const Root = styled(Box)(({ theme }) => ({
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  marginTop: 'auto',
}));

const StyledSideMenuBox = styled(SideMenuBox)<{ isOpen: boolean }>(({ theme, isOpen }) => ({
  paddingTop: theme.spacing(2),
  paddingRight: isOpen ? theme.spacing(2) : theme.spacing(1),
  paddingBottom: theme.spacing(2),
  paddingLeft: isOpen ? theme.spacing(2) : theme.spacing(1),
  ['& .MuiListItemButton-root']: {
    paddingLeft: isOpen ? theme.spacing(1) : theme.spacing(0.25),
    paddingRight: theme.spacing(0),
    transition: theme.transitions.create('padding-left'),
  },
}));
